import each from 'lodash/each';
import without from 'lodash/without';

const getContentItemsExcept = currentContentItem => {
  const allElements = document.querySelectorAll('.content-item');
  const neighborElements = without(allElements, currentContentItem);

  return neighborElements;
};

const setDisplayForAllExcept = display => currentContentItem => {
  const contentItems = getContentItemsExcept(currentContentItem);

  each(contentItems, element => {
    element.style.display = display;
  });
};

const CONTENT_ITEM_FIXED_CLASS = 'content-item--fixed';

export const addContentItemFixedClass = currentContentItem =>
  currentContentItem.classList.add(CONTENT_ITEM_FIXED_CLASS);

export const removeContentItemFixedClass = () => {
  const elements = document.querySelectorAll(`.${CONTENT_ITEM_FIXED_CLASS}`);
  each(elements, element => element.classList.remove(CONTENT_ITEM_FIXED_CLASS));
};

const MINIMIZE_ICON_CLASS = 'icon-minimize';
const FULLSCREEN_ICON_CLASS = 'icon-fullscreen';

export const replaceFullScreenIconWithMinimizeIcon = currentContentItem => {
  const fullScreenIcon = currentContentItem.querySelector(`.${FULLSCREEN_ICON_CLASS}`);
  fullScreenIcon.classList.replace(FULLSCREEN_ICON_CLASS, MINIMIZE_ICON_CLASS);
};

export const replaceMinimizeIconsWithFullScreenIcons = () => {
  const minimizeIcons = document.querySelectorAll(`.${MINIMIZE_ICON_CLASS}`);

  each(minimizeIcons, icon =>
    icon.classList.replace(
      MINIMIZE_ICON_CLASS,
      FULLSCREEN_ICON_CLASS
    )
  );
};

export const showAllContentItems =
  setDisplayForAllExcept(null);

export const showContentItemsExcept =
  setDisplayForAllExcept(null);

export const hideContentItemsExcept =
  setDisplayForAllExcept('none');
